<script>
export default {
  name: "ColorDealClasification",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const clasification = context.props.row.Clasificacion;
    const amount = context.props.row.TotalAmount;
    // este se usa para kpi de Prospeccion
    if (amount > 0 && context.props.column === "TotalAmount") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--plain"
        },
        amount
      );
    }

    if (clasification == "A") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--plain"
        },
        "A"
      );
    } else if (clasification == "B") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        "B"
      );
    } else if (clasification == "C") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--plain"
        },
        "C"
      );
    } else if (clasification == "D") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--plain"
        },
        "D"
      );
    }

    return createElement(
      "span",
      {
        class: "el-tag  el-tag--danger el-tag--plain"
      },
      "Error!"
    );
  }
};
</script>
